import * as yup from 'yup';
import { validarCNPJ } from '../../../../../services/utils';

export const formBuyerValidator = yup.object().shape({
    cnpj: yup
        .string()
        .required("Campo obrigatório")
        .test('cnpj-valido', 'Favor inserir um CNPJ válido', (value) => {
            if (value) {
                return validarCNPJ(value);
            } else {
                return false;
            }
        }),
    razaoSocial: yup
        .string()
        .required("Campo obrigatorio"),
    nomeFantasia: yup
        .string()
        .required("Campo obrigatorio")
});

export const mapearData = (empresaBuyer) => {
    let data = {
        cnpj: empresaBuyer.cnpj,
        ie: empresaBuyer.ie,
        im: empresaBuyer.im,
        razaoSocial: empresaBuyer.razaoSocial,
        nomeFantasia: empresaBuyer.nomeFantasia,
        tipo: empresaBuyer.tipo,
        porte: empresaBuyer.porte,
        numeroLojas: empresaBuyer.numeroLojas,
        numeroCheckouts: empresaBuyer.numeroCheckouts,
        faturamentoMedio: empresaBuyer.faturamentoMedio,
        banco: empresaBuyer.banco,
        agencia: empresaBuyer.agencia,
        contaCorrente: empresaBuyer.contaCorrente,
        endereco: {
          cep: empresaBuyer.cep,
          logradouro: empresaBuyer.logradouro,
          numero: empresaBuyer.numero,
          complemento: empresaBuyer.complemento,
          bairro: empresaBuyer.bairro,
          cidade: empresaBuyer.cidade,
          estado: empresaBuyer.estado,
          urlGoogleMaps: empresaBuyer.urlGoogleMaps
        },
        telefone: {
          ddd: empresaBuyer.telefone.substring(0, 2),
          numero: empresaBuyer.telefone.substring(2, empresaBuyer.telefone.length)
        }
    }

    return data;
}

export const mapearResponseApi = (data) => {
    let response = {
        cnpj: data.cnpj,
        ie: data.ie,
        im: data.im,
        razaoSocial: data.razaoSocial,
        nomeFantasia: data.nomeFantasia,
        ativo: data.ativo,
        tipo: data.tipo,
        porte: data.porte,
        numeroLojas: data.numeroLojas,
        numeroCheckouts: data.numeroCheckouts,
        faturamentoMedio: data.faturamentoMedio,
        cep: (data.endereco!=null?data.endereco.cep:''),
        logradouro: (data.endereco!=null?data.endereco.logradouro:'') ,
        numero: (data.endereco!=null? data.endereco.numero:''),
        complemento: (data.endereco!=null?data.endereco.complemento:''),
        bairro: (data.endereco!=null?data.endereco.bairro:''),
        cidade: (data.endereco!=null?data.endereco.cidade:''),
        estado: (data.endereco!=null?data.endereco.estado:''),
        urlGoogleMaps: (data.endereco!=null?data.endereco.urlGoogleMaps:''),
        telefone: (data.telefone!=null?data.telefone.ddd + data.telefone.numero:''),
        banco: data.banco,
        agencia: data.agencia,
        contaCorrente: data.contaCorrente
    }

    return response;
}

export const formBuyerInitialState = {
    cnpj: "",
    ie: "",
    im: "",
    ativo: false,
    razaoSocial: "",
    nomeFantasia: "",
    tipo: "selecione",
    porte: "",
    numeroLojas: 0,
    numeroCheckouts: 0,
    faturamentoMedio: "0",
    cep: "",
    logradouro: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    estado: "",
    urlGoogleMaps: "",
    telefone: "",
    banco: "",
    agencia: "",
    contaCorrente: ""
};